import { mockRecordsTabQueryOperationQuery } from '__generated__';

import { RECORD_SCHEMA_JSON } from '@sbu/configs.mocks';

export const handlers = [
  mockRecordsTabQueryOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        recordSchema: JSON.stringify(RECORD_SCHEMA_JSON),
      })
    );
  }),
];
